// extracted by mini-css-extract-plugin
export default {"brandPromo":"KH-z","carousel":"LH-z"};